import { Box, Button, Typography } from "@mui/material";
import lockBlock from "../../assets/imgs/imgErrosPage/lockBlock.png";
import { maskPhone } from "../../utils/masks";
import useStyles from "./styles";


const formatarTelefone = (whatsapp) => {
  const digitos = String(whatsapp || "").replace(/\D/g, "");
  if (!digitos) return "";
  const local = digitos.startsWith("55") ? digitos.slice(2) : digitos;
  return maskPhone(local) || "";
};

// const TEXTOS_PROVISIONAMENTO = {
//   AGUARDANDO_PROVISIONAMENTO: {
//     etiqueta: "Instalação aguardando liberação",
//     titulo: "Instalação ainda não provisionada",
//     descricao:
//       "Esta instalação já se apresentou ao Cactus e está esperando a liberação da licença.",
//   },
//   NAO_CONFIGURADA: {
//     etiqueta: "Instalação não configurada",
//     titulo: "Instalação sem identificação",
//     descricao:
//       "Falta informar qual cliente é esta instalação para que a licença possa ser liberada.",
//   },
// };

const TEXTO_PADRAO = {
  etiqueta: "Acesso temporariamente indisponível",
  titulo: "Sistema indisponível no momento",
  descricao: "Seus dados estão salvos. Entre em contato com o suporte.",
};

export default function SystemBlockedPage({
  whatsapp = "",
  email = "",
  motivo = null,
}) {
  const styles = useStyles();

  const textos = TEXTO_PADRAO;
  const telefone = formatarTelefone(whatsapp);
  const contatos = [email, telefone].filter(Boolean).join("  ·  ");

  const abrirWhatsapp = () => {
    window.open(`https://wa.me/${whatsapp}`, "_blank", "noopener,noreferrer");
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.circulo} />

      <Box sx={styles.conteudo}>
        <Box sx={styles.coluna}>
          <Box sx={styles.etiqueta}>
            <Box sx={styles.ponto} />
            <Typography component="span" sx={styles.etiquetaTexto}>
              {textos.etiqueta}
            </Typography>
          </Box>

          <Typography component="h1" sx={styles.titulo}>
            {textos.titulo}
          </Typography>

          <Typography sx={styles.descricao}>{textos.descricao}</Typography>

          {!!whatsapp && (
            <Button variant="contained" sx={styles.botao} onClick={abrirWhatsapp}>
              Contato Suporte
            </Button>
          )}

          {!!contatos && <Typography sx={styles.rodape}></Typography>}
        </Box>

        <Box sx={styles.colunaImagem}>
          <Box
            component="img"
            src={lockBlock}
            alt="Sistema bloqueado"
            sx={styles.imagem}
          />
        </Box>
      </Box>
    </Box>
  );
}
